import type { ReactNode } from 'react'

import { HeroShape } from '@/assets/images'
import { Leaf1, Leaf2, Leaf3, Leaf4, Leaf5 } from '@/assets/svg'
import { LeafStep } from '@/components/ui/leaf-step'
import { MarketingButton } from '@/components/ui/marketing-button'
import { SearchJob } from '@/components/sections/search-job'
import { env } from '@/config/env'

// `title` is a ReactNode instead of legacy's HTML string: the only markup any caller ever passed
// was a <br /> ("Dream big.<br />Hire big."), and taking JSX removes the
// dangerouslySetInnerHTML + dompurify pair entirely.
export function HeroSection({
  title,
  description,
  isEmployer = false,
}: {
  title: ReactNode
  description: string
  isEmployer?: boolean
}) {
  return (
    <section className={`hero-section${isEmployer ? ' isEmployer' : ''}`}>
      {!isEmployer && <SearchJob />}

      <div className="hero-section-inner container">
        <div className="hero-section-content">
          <h1>{title}</h1>
          <p>{description}</p>

          {/* Legacy pointed this CTA at the talent app root; preserved (Phase 1). */}
          {isEmployer && <MarketingButton href={env.talentAppUrl}>Start hiring now</MarketingButton>}
        </div>

        <div className="hero-section-image">
          <img src={HeroShape} alt="" />
        </div>
      </div>

      {isEmployer && (
        <div className="hero-section-grid container">
          <LeafStep
            icon={Leaf1}
            heading="Job Requirement"
            description="Build a job description for to be filled"
          />
          <LeafStep
            icon={Leaf2}
            heading="Talent Sourcing"
            description="Make it public about the vacancy that exists"
          />
          <LeafStep
            icon={Leaf3}
            heading="Interview & Selection"
            description="Shortlist the successful"
          />
          <LeafStep
            icon={Leaf4}
            heading="Job Requirement"
            description="Build a job description for to be filled"
          />
          <LeafStep
            icon={Leaf5}
            heading="Final Placement"
            description="Employ staff and make placement"
          />
        </div>
      )}
    </section>
  )
}
